"use strict";

var async_1 = require("./async");

module.exports = async_1.asyncMemoizer;